import React from 'react';
import './components.css';
import Logo from './media/logo2.png';
import { Link } from 'react-router-dom'

const NavLogo = () => {
	return (
		<div className='sub-nav-properties nav-logo'>
			<Link to='about'><img src={Logo}/></Link>
		</div>
)
};

export default NavLogo; 
